import { useContext, useState } from "react";
import { Position } from "reactflow";
import GoToIcon from "../../assets/images/gotoicon-purple.svg";
import AddNodeSelector from "../../components/AddNodeSelector";
import DeleteIconImg from "../../assets/images/deleteIcon.svg";
import NodeContext from "../../context/NodeContext";
import {
  ActionButtonContainer,
  StyledJumpToProfileNode,
} from "./JumpToProfile.styled";
import { TopEdge } from "../StartingNode/StartingNode.styled";
import { Button } from "../../components/ui/button";

function JumpToProfile(props) {
  const { id, data } = props;
  const { titleText, isTop, active } = data;
  const [showAddBox, setShowAddBox] = useState(false);
  const { handleNodeClick, deleteNode, selectedNodeInfo, isEditable } = useContext(NodeContext);
  const [visible, setVisible] = useState(false);


  return (
    <>
      {isTop ? (
        <TopEdge
          type="target"
          position={Position.Top}
          id="top"
          isConnectable={true}
          iseditable={isEditable ? "true" : undefined}
        />
      ) : null}
      <StyledJumpToProfileNode
        $isActive={active ? active : selectedNodeInfo?.id === id}
        onClick={() => handleNodeClick(id)}
      >
        <div className="titleContainer">
          <img src={GoToIcon} alt="GoToIcon" className="jumpToprofile" />
          <span className="titleText">{titleText}</span>
        </div>

        {isEditable && <ActionButtonContainer
          className="action-btns"
          onClick={(e) => e.stopPropagation()}
        >
          <img
            src={DeleteIconImg}
            alt="deleteIcon"
            onClick={() => {
              setVisible(!visible);
              // deleteNode(id);
            }}
          />
        </ActionButtonContainer>}
        {visible && isEditable && (
          <ActionButtonContainer
            className="action-btns"
            onClick={(e) => e.stopPropagation()}
            style={{
              right: "-315px",
              top: "-35px",
              height: "auto",
              width: "250px",
              padding: "10px",
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                fontFamily: "Plus Jakarta Sans, sans-serif",
                marginBottom: "10px",
                color: "#000",
              }}
            >
              Are you sure you want to delete?
            </span>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "150px",
                margin: "auto",
                padding: "10px 8px",
                gap: "20px",
              }}
            >
              <Button
                variant="outline"
                className="rounded-[5px] px-[10px] py-[5px] h-auto border-[#007372] text-[#007372] hover:bg-teal-50 hover:text-[#007372] hover:border-[#007372]"
                onClick={(e) => {
                  e.stopPropagation();
                  setVisible(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="outline"
                className="rounded-[5px] px-[10px] py-[5px] h-auto border-[#ef4949] text-[#ef4949] hover:bg-red-50 hover:text-[#ef4949] hover:border-[#ef4949]"
                onClick={() => {
                  setVisible(false);
                  deleteNode(id);
                }}
              >
                Delete
              </Button>
            </div>
          </ActionButtonContainer>
        )}

        {showAddBox ? (
          <AddNodeSelector nodeData={props} setShowAddBox={setShowAddBox} />
        ) : null}
      </StyledJumpToProfileNode>
    </>
  );
}

export default JumpToProfile;
